import $ from 'jquery';
import { openModal } from '../ui/modal';

export default function() {
	$(document).ready(() => {
		const $redirectModalContentLink = $('a.open-redirect-content');

		if ($redirectModalContentLink.length) {
			$('#redirect-modal-content').removeClass('hidden');
			openModal($redirectModalContentLink, { compact: true, centerVertical: true });
		}
	});
}
